import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { fetchAggResponse } from '../../../../common';
import { DefinitionEditHistoryGQL } from '../../gql/edit-history-query';
import { getProductScope } from './utils';
export var useDefinitionEditHistory = function useDefinitionEditHistory(_ref) {
  var _data$knowledgeDiscov, _data$knowledgeDiscov2;
  var query = _ref.query,
    curatedDefinitionScopeConfig = _ref.curatedDefinitionScopeConfig;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var loading = data === undefined && error === undefined;
  var scopeIds = getProductScope(curatedDefinitionScopeConfig.productScopes);
  useEffect(function () {
    var fireRequest = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, _data, errors;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchAggResponse({
                graphQuery: DefinitionEditHistoryGQL.query,
                operationName: DefinitionEditHistoryGQL.operationName,
                variables: _objectSpread({
                  workspaceId: curatedDefinitionScopeConfig.workspaceId,
                  keyPhrase: query
                }, scopeIds)
              });
            case 3:
              res = _context.sent;
              _data = res.data, errors = res.errors;
              if (!(!errors && !!_data)) {
                _context.next = 9;
                break;
              }
              setData(_data);
              _context.next = 10;
              break;
            case 9:
              throw new Error(errors === null || errors === void 0 ? void 0 : errors.map(function (e) {
                return e.message;
              }).join(', '));
            case 10:
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              setError(_context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 12]]);
      }));
      return function fireRequest() {
        return _ref2.apply(this, arguments);
      };
    }();
    fireRequest();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var definitions = !error && !(data !== null && data !== void 0 && (_data$knowledgeDiscov = data.knowledgeDiscovery) !== null && _data$knowledgeDiscov !== void 0 && (_data$knowledgeDiscov = _data$knowledgeDiscov.definitionHistory) !== null && _data$knowledgeDiscov !== void 0 && _data$knowledgeDiscov.message) ? (data === null || data === void 0 || (_data$knowledgeDiscov2 = data.knowledgeDiscovery) === null || _data$knowledgeDiscov2 === void 0 || (_data$knowledgeDiscov2 = _data$knowledgeDiscov2.definitionHistory) === null || _data$knowledgeDiscov2 === void 0 ? void 0 : _data$knowledgeDiscov2.definitions) || [] : [];
  return {
    definitions: definitions,
    loading: loading
  };
};